import info from '../package.json'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import { mapActions } from 'vuex'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import { Ripple } from 'vuetify/lib/directives'
import App from './App.vue'
import {
  LayoutPlugin,
  ButtonPlugin,
  CardPlugin,
  CollapsePlugin,
  NavbarPlugin,
  ModalPlugin
} from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'
import UploadButton from 'vuetify-upload-button'
import VueSweetalert2 from 'vue-sweetalert2'
import VueSentry from '@/utils/sentry'
import { datadogRum } from '@datadog/browser-rum'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuetify/dist/vuetify.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'

import '@/utils/filters'

// Datadog RUM is only enabled in production
if (
    JSON.parse(process.env.VUE_APP_TOGGLE_DATADOG) &&
    !process.env.VUE_APP_ENV
  ) {
  datadogRum.init({
    applicationId: '3464a4a1-b711-4448-b7ef-8f95ec2ae24d',
    clientToken: 'pub6d3080aa814cfa796ecb315a175a9011',
    site: 'datadoghq.com',
    service: 'devices',
    env: process.env.VUE_APP_ENV || process.env.NODE_ENV,
    version: info.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    enableExperimentalFeatures: ['clickmap'],
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [process.env.VUE_APP_API_URL, (url) => url.startsWith(process.env.VUE_APP_API_URL)]
  })

  datadogRum.startSessionReplayRecording()
}

Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin)
Vue.use(ModalPlugin)
Vue.use(ButtonPlugin)
Vue.use(CollapsePlugin)
Vue.use(CardPlugin)
Vue.use(vuetify, {
  directives: {
    Ripple
  }
})
Vue.use(VueTheMask)
Vue.use(UploadButton)
Vue.use(VueSweetalert2)
Vue.use(...VueSentry)

Vue.prototype.$partner = null
const { groups } =
  /client_id=key-(?<partner>.*)-external-(prd|hml|dev)/.exec(
    window.location.href
  ) || {}

if (groups && groups.partner) {
  Vue.prototype.$partner = groups.partner
}

new Vue({
  vuetify,
  router,
  store,
  methods: {
    ...mapActions(['actionPatchLead'])
  },
  render: (h) => h(App)
}).$mount('#app')
